//% Link
import {Link} from "react-router-dom";

//% Components
import ProductCard from "../product-card/product-card.component";

//% Styles
import "./category-preview.styles.scss";

interface CategoryPreviewProps {
  title: string;
  products: Product[];
}
const CategoryPreview = (props: CategoryPreviewProps) => {
  const {title, products} = props;
  return (
    <div className="category-preview-container">
      <h2>
        <Link className="title" to={title}>
          {title.toUpperCase()}
        </Link>
      </h2>

      <div className="preview">
        {products
          .filter((_, idx) => idx < 4)
          .map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
      </div>
    </div>
  );
};

export default CategoryPreview;
